




import { Component, Vue, Watch } from 'vue-property-decorator';

import AgentDetails from './AgentDetails.vue';

@Component
export default class AgentDetailsProxy extends Vue {

  modal: any = null;

  public mounted() {
    this.onParamsChange()
  }

  @Watch('$route.params')
  onParamsChange() {
    console.log('$route.params', this.$route.params)
    if(this.modal) {
      this.modal.close();
    }

    this.modal = this.$buefy.modal.open({
      component: AgentDetails,
      props: {
        params: this.$route.params
      },
      onCancel: () => {
        this.$router.back()
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form',
      parent: this
    })
  }

  beforeDestroy() {
    this.modal.close();
  }

}
